export default {
  scheduleCall: 'Planifier un appel',
  changeLanguage: 'English',
  completion: '{{progress}}% du questionnaire complété',
};
